(() => {
  if (window.__neatHomeMotion) return;
  window.__neatHomeMotion = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = [];
  const immediateItems = [];

  const register = (selector, type = 'text', stagger = 85, immediate = false) => {
    document.querySelectorAll(selector).forEach((element, index) => {
      if (element.dataset.neatMotionBound === 'true') return;

      element.dataset.neatMotionBound = 'true';
      element.classList.add('neat-reveal', `neat-reveal--${type}`);
      element.style.setProperty('--neat-delay', `${Math.min(index, 7) * stagger}ms`);
      revealItems.push(element);

      if (immediate) immediateItems.push(element);
    });
  };

  register('.nd-nav__logo, .nd-nav__links, .nd-nav__cta, .nd-nav__mobile', 'text', 90, true);
  register('.nd-hero__headline > p, .nd-hero__headline > h1, .nd-hero__intro, .nd-hero__actions', 'text', 110, true);
  register('.nd-motion__topline, .nd-motion__footer', 'text', 100);
  register('.nd-bento__header > p, .nd-bento__header > h2', 'text', 100);
  register('.nd-bento__card', 'card', 85);
  register('.nd-work__header > div, .nd-work__intro, .nd-work__footer', 'text', 100);
  register('.nd-work__card', 'card', 80);
  register('.nd-services__eyebrow, .nd-services__intro h2, .nd-services__lede, .nd-services__stamp, .nd-services__cta, .nd-services__footer', 'text', 80);
  register('.footer-content > *, .utilities > *', 'text', 70);

  document.documentElement.classList.add('neat-motion-ready');

  const show = (element) => element.classList.add('is-neat-visible');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach(show);
    return;
  }

  requestAnimationFrame(() => requestAnimationFrame(() => immediateItems.forEach(show)));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      show(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    threshold: .06,
    rootMargin: '0px'
  });

  revealItems.forEach((element) => {
    if (!immediateItems.includes(element)) observer.observe(element);
  });
})();
